import type React from 'react';

import { Text } from '@change/ds-core-ui';
import {
	ChatBubbleIcon,
	type Icon,
	LockIcon,
	MediaIcon,
	ReminderIcon,
	SpeakerIcon,
	TrendingIcon,
} from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import type { LandingPageSlug } from '#src/app/pages/landing/template/pageContext';

type Props = {
	slug: LandingPageSlug;
};

const items: ReadonlyArray<{ Icon: React.FC<Icon>; key: string }> = [
	{ Icon: MediaIcon, key: 'publish' },
	{ Icon: ReminderIcon, key: 'fast' },
	{ Icon: TrendingIcon, key: 'signatures' },
	{ Icon: ChatBubbleIcon, key: 'advice' },
	{ Icon: SpeakerIcon, key: 'reach' },
	{ Icon: LockIcon, key: 'secure' },
];

export const Footer: React.FC<Props> = ({ slug }) => {
	return (
		<div className="bg-background-raised w-full px-6 py-10 md:px-10 md:py-16">
			<div className="container">
				<Text size="x-large" className="text-center">
					<Translate value={`landing.${slug}.footer.title`} />
				</Text>
				<div className="mt-8 grid grid-cols-1 gap-x-8 gap-y-4 md:grid-cols-3">
					{items.map(({ Icon: ItemIcon, key }) => {
						return (
							<div key={key} className="flex">
								<ItemIcon size={28} className="text-icon-brand mr-4" />
								<div className="flex-1">
									<Text className="mb-2 md:font-bold">
										<Translate value={`landing.${slug}.footer.${key}.title`} />
									</Text>
									<div className="hidden md:block">
										<Text as="p">
											<Translate value={`landing.${slug}.footer.${key}.body`} />
										</Text>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};
